import { TransportType } from "@syla/shared/types/helpers/TransportType";
import { GetSubscriptionsResponse } from "@syla/shared/types/responses/GetSubscriptionsResponse";
import axios from "axios";
import { parseSubscription } from "./parseSubscription";

export async function getSubscriptions(
  accountId: string,
): Promise<GetSubscriptionsResponse> {
  const response = await axios.get<TransportType<GetSubscriptionsResponse>>(
    `/accounts/${accountId}/subscriptions`,
  );

  return {
    subscriptions: response.data.subscriptions.map(parseSubscription),
  };
}
